import * as React from 'react';
import type { Acesso, Funcionalidade } from '@/data/types';
import { ACESSO_LIBERADO } from '@/lib/acesso';

/**
 * Acesso às funcionalidades (`GET /v1/me` -> `acesso`), carregado UMA vez no
 * boot do App junto das roles. Enquanto `carregando`, quem decide mostra
 * skeleton — nunca "sem acesso" nem a tela errada por um instante.
 */
export interface AcessoContexto {
  carregando: boolean;
  colaborador: boolean;
  acesso: Acesso;
  /** Relê em silêncio (depois de o admin mudar a visibilidade). */
  recarregar: () => void;
}

export const AcessoContext = React.createContext<AcessoContexto>({
  carregando: false,
  colaborador: true,
  acesso: ACESSO_LIBERADO,
  recarregar: () => {},
});

export function useAcesso(): AcessoContexto {
  return React.useContext(AcessoContext);
}

/**
 * A UI mostra/atua em uma funcionalidade quando `acesso[f]` é true. A API já
 * devolve `true` para STAFF (admin/maintainer/painel/sysadmin) mesmo com
 * audiência `oculto` — quem opera o sistema nunca tem funcionalidade escondida.
 */
export function usePodeVer(funcionalidade: Funcionalidade): boolean {
  const { acesso, carregando } = useAcesso();
  return !carregando && acesso[funcionalidade];
}
